import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { reduxForm } from 'redux-form';
import ButtonGroup from '../../components/button-group';
import { LinkIcon } from '../../components/icons';
import withTranslate from '../../hoc/with-translate';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './text-editor-link-form.scss';

const getFieldProps = field => ({
  value: field.value,
  onChange: field.onChange,
  onFocus: field.onFocus,
  onBlur: field.onBlur,
});
const TextEditorLinkForm = props => {
  const { fields: { url }, handleSubmit, onCancel, t, titleFontClassName, contentFontClassName } = props;
  return (
    <div className={classNames(styles.container, contentFontClassName, 'forum-text-color')}>
      <div className={classNames(styles.titleWrapper, titleFontClassName)}>
        <LinkIcon className="forum-icon-fill"/>
        <span className={styles.title}>
          {t('text-editor-link-form.title')}
        </span>
      </div>
      <div className={styles.inputWrapper}>
        <input
          className={styles.input}
          autoFocus
          placeholder={t('text-editor-link-form.placeholder')}
          {...getFieldProps(url)}
          data-hook="link-input"
        />
        <div className={classNames(styles.border, 'forum-text-border-color')}/>
      </div>
      <ButtonGroup
        primaryButtonText={t('text-editor-link-form.button')}
        primaryButtonProps={{ onClick: handleSubmit }}
        secondaryButtonText={t('text-editor-link-form.cancel-button')}
        secondaryButtonProps={{ onClick: () => onCancel() }}
      />
    </div>
  );
};

TextEditorLinkForm.propTypes = {
  fields: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
};

export default reduxForm({
  form: 'text-editor-link',
  fields: ['url'],
})(withTranslate(withFontClassName(TextEditorLinkForm)));



// WEBPACK FOOTER //
// ./app/components/text-editor-link-form/text-editor-link-form.js